import { Reveal, SectionTag } from "./Reveal";
import { TECH_CARDS, IMG } from "../data/content";

export default function Technology() {
  return (
    <section id="technology" data-testid="technology-section" className="relative py-24 lg:py-32">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal>
          <SectionTag index="04" label="Technology & Data" />
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-ice leading-[0.95] max-w-4xl">
            Instruments of <span className="text-polar">observation</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-ice/70 leading-relaxed">
            Data selection depends on the scientific question, available products, spatial resolution and temporal
            alignment. Satellite observations, derived indicators and field measurements are distinct things — and the
            programme treats them that way.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-4 mt-14">
          {TECH_CARDS.map((t, i) => (
            <Reveal key={t.code} delay={0.05 * i} className={i < 3 ? "md:col-span-4 lg:col-span-4" : i < 5 ? "md:col-span-4 lg:col-span-6" : "md:col-span-4 lg:col-span-6"}>
              <div
                className="group relative bg-[#0B1F35]/80 border border-polar/15 p-6 sm:p-7 h-full hover:border-gold/50 transition-colors duration-300"
                data-testid={`tech-card-${t.code.toLowerCase()}`}
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[10px] tracking-[0.25em] px-2.5 py-1 border border-polar/30 text-polar">
                    {t.code}
                  </span>
                  <span className="w-1.5 h-1.5 rounded-full bg-tech/50 group-hover:bg-gold transition-colors duration-300" aria-hidden="true" />
                </div>
                <h3 className="font-display font-semibold text-xl sm:text-2xl text-ice mt-5 tracking-wide">{t.title}</h3>
                <p className="text-sm text-ice/60 mt-2 leading-relaxed">{t.desc}</p>
              </div>
            </Reveal>
          ))}

          <Reveal delay={0.1} className="md:col-span-8 lg:col-span-12">
            <div className="relative clip-corner overflow-hidden h-56 sm:h-72">
              <img src={IMG.satEarth2} alt="Satellite imagery texture of Earth surface" className="w-full h-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-r from-abyss/90 via-abyss/40 to-transparent" />
              <div className="absolute inset-0 grid-overlay opacity-50" />
              <div className="absolute bottom-5 left-5 sm:bottom-8 sm:left-8 max-w-md">
                <div className="font-mono text-[10px] tracking-[0.25em] text-polar mb-2">FIG.03 — ORBITAL OBSERVATION</div>
                <p className="font-display font-semibold text-xl sm:text-2xl text-ice tracking-wide leading-tight">
                  No invented datasets. No claimed accuracy scores. No fabricated ground truth.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
